import { Injectable } from '@angular/core';

import { TSFixme } from '../../app/models/TSFixme';
import { QuoteSessionService } from '../store/session/session.service';

@Injectable({ providedIn: 'root' })
export class UserTokenService {
	constructor(private readonly quoteSessionService: QuoteSessionService) { }

	public setUserData(auth0UserToken: TSFixme): void {
		if (auth0UserToken === null) return;
		/**
		 * gets the custom claim value from the Auth0 user record
		 *
		 * @param customClaim the string value for the claim that you want to get from the user token
		 */
		const getCustomClaims = (customClaim: string): string => auth0UserToken[`http://embracepetinsurance.cm/claims/${customClaim}`];
		/** Update the contact values from the USAA user record's custom claims */
		this.quoteSessionService.updateContact({
			ratingZipCode: getCustomClaims(`zip_code`),
			firstName: getCustomClaims(`first_name`),
			lastName: getCustomClaims(`last_name`),
			phoneNumber: getCustomClaims(`phone_number`),
			emailAddress: getCustomClaims(`email`),
		});
		/** Update the contacts mailing address from the USAA user record's custom claims */
		this.quoteSessionService.updateMailingAddress({
			addressLine1: getCustomClaims(`street1`),
			city: getCustomClaims(`city`),
			state: getCustomClaims(`state`),
			zipCode: getCustomClaims(`zip_code`),
		});

	}

	public getMemberNumberFromToken(auth0UserToken: TSFixme): string | null {
		if (auth0UserToken === null) return null;
		const userId =  auth0UserToken[`http://embracepetinsurance.cm/claims/user_id`];
		if (userId !== null && userId !== undefined && userId.includes(`|`)) {
			const parts = userId.split(`|`);
			if (parts.length === 3) { // eslint-disable-line @typescript-eslint/no-magic-numbers
				return parts[2];
			} else {

				return null;
			}
		}

		return null;
	}
}
